enum MirrorPageEnums {
  BASE = '/seguro-vehicular/autoefectivo',
  DEFAULT_EMAIL = 'usuario@pacifico.com.pe',
  PARAM = 'canal',
  ANTIQUITY_LOWER = '/seguro-vehicular/autoefectivo-a',
  ANTIQUITY_HIGHER = '/seguro-vehicular/autoefectivo-b',
  BCP = '/seguro-vehicular/autoefectivo-bcp',
  YAPE = '/seguro-vehicular/autoefectivo-yape',
  TAXI = '/seguro-vehicular/autoefectivo-taxi',
  LAUNCH = '/seguro-vehicular/autoefectivo-lanzamiento',
}

export default MirrorPageEnums;
